"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const actions_1 = require("../app/actions/actions");
const INIT_STATE = {
    mainStep: { no: 1 },
    ProjectInfo: {
        projectname: "",
        problemtype: "",
        version_name: "",
    },
    ProjectInitiationData: {},
};
exports.default = (state = INIT_STATE, action) => {
    switch (action.type) {
        case actions_1.CHANGE_MAIN_STEP: {
            console.log(action.payload);
            return Object.assign({}, state, { no: action.payload });
        }
        case actions_1.SAVE_PROJECT_INFO: {
            return Object.assign({}, state, { projectname: action.payload.projectname, problemtype: action.payload.problemtype, version_name: action.payload.version_name });
        }
        case actions_1.SAVE_PROJECT_INIT_DATA: {
            return Object.assign({}, state, { data: action.payload });
        }
        default:
            return state;
    }
};
//# sourceMappingURL=main-step.js.map